import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const dateRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const startDate = control.get('startDate')?.value;
  const endDate = control.get('endDate')?.value;

  if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
    return { dateRangeInvalid: true };
  }

  return null;
};

export function autocompleteSelectionValidator(suggestionsProvider: () => any[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || typeof control.value !== 'object') {
      return { invalidSelection: true };
    }

    const suggestions = suggestionsProvider();
    const isValidSelection = suggestions.some(suggestion => suggestion.value === control.value.value);

    return isValidSelection ? null : { invalidSelection: true };
  };
}


